import TrainsMapButtonController from './controllers/trains-map-button-controller';
import TrainsTypeaheadBaseController from './controllers/trains-typeahead-base-controller';
import TrainMoreOptions from './directives/train-more-options-directive';
import TrainTravellers from './directives/train-traveller-directive';
import TrainLabelFilter from './filters/train-label-filter';
import TrainsApiService from './services/trains-api-service';
import TrainsSearchParamsFactory from './services/trains-search-params';
import trainsFactoryConstructor from './services/trains-factory-constructor';
import TrainsUtilsFactory from './services/trains-utils';

const MODULE_NAME = 'App.Trains.Base';
const module = angular
    .module(MODULE_NAME, [
        'app.constants',
    ])
    .controller('TrainsMapButtonController', TrainsMapButtonController)
    .controller('TrainsTypeaheadBaseController', TrainsTypeaheadBaseController)
    .directive('ktTrainMoreOptions', TrainMoreOptions)
    .directive('ktTrainTravellers', TrainTravellers)
    .factory('trainsApiService', TrainsApiService)
    .factory('TrainsSearchParams', TrainsSearchParamsFactory)
    .factory('trainsFactoryConstructor', trainsFactoryConstructor)
    .factory('trainsUtils', TrainsUtilsFactory)
    .filter('trainLabel', TrainLabelFilter);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/trains-base-module.js